import React from "react";

export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`relative flex overflow-hidden border-y border-line bg-panel-raised py-5 sm:py-6 ${className}`}>
      <div className="flex shrink-0 animate-marquee items-center gap-8 pr-8 sm:gap-14 sm:pr-14">
        {row.map((it, i) => (
          <div key={i} className="flex items-center gap-8 sm:gap-14">
            <span className="whitespace-nowrap font-display text-xl font-light tracking-tight text-content-faint sm:text-2xl md:text-3xl">
              {it}
            </span>
            <span className="text-brand/50">✦</span>
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-panel-raised to-transparent sm:w-32" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-panel-raised to-transparent sm:w-32" />
    </div>
  );
}
